<template>
  <div class="step-loader-container">
    <div
      class="step-loader-container--inner"
      :style="{
        transform: `translateX(${-100 * activeComponentIndex}%)`
      }"
    >
      <div
        v-for="(vnode, key) in vnodes"
        :key="key"
        class="step-item"
        :class="{ 'step-item--active': activeComponentIndex === key }"
      >
        <v-node :vnode="vnode" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepLoader",
  props: {
    percentage: Number
  },
  components: {
    VNode: {
      functional: true,
      render: (h, ctx) => {
        return ctx.data.attrs.vnode;
      }
    }
  },
  computed: {
    vnodes() {
      return this.$slots.default;
    },
    activeComponentIndex() {
      const cantSteps = this.vnodes.length;
      for (let i = 1; i <= cantSteps; i++) {
        const max = i * (100 / cantSteps);
        const min = max - 100 / cantSteps;
        if (this.percentage >= min && this.percentage <= max) {
          return i - 1;
        }
      }

      return cantSteps - 1;
    }
  }
};
</script>

<style scoped>
.step-loader-container {
  width: 100%;
  overflow: hidden;
  padding: 0 100px;
}
.step-loader-container--inner {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 1s ease-in-out;
  transform: translateX(0%);
}
.step-item {
  flex-basis: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  opacity: 0.3;
  transition: all 1s ease-in-out;
}
.step-item--active {
  opacity: 1;
}
</style>
